import * as React from 'react';
import { Button } from '~/Partials/Button/Button';
import { ButtonSize } from '~/Partials/Button/ButtonSize.csharp';
import { ButtonTier } from '~/Partials/Button/ButtonTier.csharp';
import { ButtonType } from '~/Partials/Button/ButtonType.csharp';
import styles from './Controls.module.css';

export interface ControlsTranslations {
    accept: string;
    cancel: string;
}

export interface ControlsProps {
    onAccept: () => void;
    onCancel: () => void;
    translations: ControlsTranslations;
    isAcceptActive?: boolean;
}

export const Controls: React.FC<ControlsProps> = props => {
    const { isAcceptActive, onAccept, onCancel, translations } = props;

    return (
        <div className={styles.Controls}>
            <div className={styles.ButtonContainer}>
                <Button
                    className={styles.Button}
                    onClick={onCancel}
                    tier={ButtonTier.Primary}
                    size={ButtonSize.Medium}
                    type={ButtonType.Outline}
                >
                    {translations.cancel}
                </Button>
            </div>
            <div className={styles.ButtonContainer}>
                <Button
                    className={styles.Button}
                    onClick={onAccept}
                    tier={ButtonTier.Secondary}
                    size={ButtonSize.Medium}
                    type={ButtonType.Solid}
                    disabled={!isAcceptActive}
                >
                    {translations.accept}
                </Button>
            </div>
        </div>
    );
};
